
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ICountryConfigResponse, IUpdateUserOID, IUser, IUserDetail } from "@/entities";

@Component({
  name: "user-detail",
})
export default class UserDetail extends Vue {
  @Action("toggleAdmin") toggleAdmin!: (idUser: number) => Promise<boolean | undefined>;
  @Action("toggleSupervisor") toggleSupervisor!: (idUser: number) => Promise<boolean | undefined>;
  @Action("toggleAprobador") toggleAprobador!: (idUser: number) => Promise<boolean | undefined>;
  @Action("fetchUserDetail") fetchUserDetail!: (idUser: number) => Promise<IUserDetail | undefined>;
  @Action("updateOIDSol") updateOIDSol!: ({
    idUser,
    updateUser,
  }: {
    idUser: number;
    updateUser: IUpdateUserOID;
  }) => Promise<string | undefined>;
  @Getter("getLoggedUser") loggedUser: IUser | undefined;
  @Prop({ required: true }) user!: IUserDetail;
  @Prop({ default: {} }) config!: ICountryConfigResponse;
  isDisableOIDSol = true;

  constructor() {
    super();
  }

  onCheckOIDSol(isChecked: boolean): void {
    this.isDisableOIDSol = isChecked;
  }
  onUpdateOIDSol(id: number): void {
    const updateOID: IUpdateUserOID = {
      oid: this.user.oid!,
    };
    this.updateOIDSol({ idUser: id, updateUser: updateOID });
  }
  switchAdmin(id: number): void {
    this.toggleAdmin(id);
  }
  switchSupervisor(id: number): void {
    this.toggleSupervisor(id);
  }
  async switchAprobador(id: number): Promise<void> {
    await this.toggleAprobador(id);
    this.$emit("change", id);
  }
}
